import { useContext, useMemo } from 'react';
import PricingTableHelper from '@bbkAdminComponents/experiences/pricing-pages-editors/helper/pricing-table-helper';
import { type Frequency } from '@bbkPricingPage/types/pricing-table-types';
import { SwitchBox, type SwitchBoxOption } from './switch-box';
import { PricingTableContext } from '../../context/pricing-table-context';

const PeriodSwitchBox = () => {
  const { pricingTable, frequency, setFrequency, subscription } =
    useContext(PricingTableContext);

  const frequencies = useMemo(() => {
    return PricingTableHelper.getUniquePeriodsFromPricingTable(
      pricingTable!
    ).filter((freq) => freq.is_attached);
  }, [pricingTable]);

  const genKey = (frequency?: Frequency | null) => {
    if (!frequency) return undefined;
    return `frequency-${frequency.period}-${frequency.period_unit}`;
  };

  const data = frequencies.map((value) => ({
    id: genKey(value),
    value: genKey(value),
    label: value.title,
  })) as SwitchBoxOption[];

  const selectedKey = genKey(frequency);

  const showFrequencySwitcher =
    frequencies.length > 1 &&
    (subscription?.status
      ? !pricingTable?.paywall_config?.hide_frequency_switch
      : true);

  if (!showFrequencySwitcher) return null;

  return (
    <div>
      <SwitchBox
        id="frequency-selector"
        data={data}
        selectedValue={selectedKey}
        onValueChange={(value) => {
          setFrequency(frequencies.find((opt) => genKey(opt) === value));
        }}
      />
    </div>
  );
};

export default PeriodSwitchBox;
